export class NonReportedError extends Error {}
